import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const HOME_LOAN_REFINANCE_SOURCES_B = [
  {
    sourceId: "home-loan-refinance-source-hardship",
    topicId: "home-loan-refinance",
    title: "Problems paying your mortgage",
    publisher: "Moneysmart",
    url: "https://moneysmart.gov.au/home-loans/problems-paying-your-mortgage",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Moneysmart 공식 본문에서 lender hardship team 조기 연락, hardship variation request, affordable repayment와 written decision timing을 확인",
    reviewStatus: "live_verified",
    claimScope: "mortgage repayment difficulty와 lender hardship process의 일반 경로",
    followUp: "현재 repayment capacity, hardship request record와 lender written response를 확인",
  },
  {
    sourceId: "home-loan-refinance-source-consolidation",
    topicId: "home-loan-refinance",
    title: "Debt consolidation and refinancing",
    publisher: "Moneysmart",
    url: "https://moneysmart.gov.au/managing-debt/debt-consolidation-and-refinancing",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Moneysmart 공식 본문에서 debt consolidation이 term·fees·secured-debt risk 때문에 총비용을 늘릴 수 있고 unrealistic promises를 경계해야 함을 확인",
    reviewStatus: "live_verified",
    claimScope: "home-loan refinance를 통한 debt consolidation의 비용·담보·재부채 위험",
    followUp: "unsecured debt를 home security에 묶기 전 lifetime interest와 default consequences를 독립적으로 검토",
  },
  {
    sourceId: "home-loan-refinance-source-asic-hardship",
    topicId: "home-loan-refinance",
    title: "Hardship threshold",
    publisher: "Australian Securities and Investments Commission",
    url: "https://asic.gov.au/for-consumers/loans-and-credit-cards/hardship-threshold/",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "ASIC 공식 소비자 안내에서 post-March 2013 credit contracts의 hardship request는 loan value threshold 없이 가능하다는 현재 경계를 확인",
    reviewStatus: "live_verified",
    claimScope: "National Credit Code hardship variation request의 threshold 일반 기준",
    followUp: "contract date, regulated credit status와 lender-specific evidence requirements 확인",
  },
  {
    sourceId: "home-loan-refinance-source-afca",
    topicId: "home-loan-refinance",
    title: "Financial hardship complaints",
    publisher: "Australian Financial Complaints Authority",
    url: "https://www.afca.org.au/make-a-complaint/financial-hardship-complaints",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "AFCA 공식 본문에서 먼저 lender hardship·internal complaint를 이용하고 해결되지 않으면 무료 external dispute resolution을 신청하는 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "lender hardship response·collection action 관련 AFCA complaint 경로",
    followUp: "lender complaint reference, final response 또는 response delay와 current AFCA time limits 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of HOME_LOAN_REFINANCE_SOURCES_B) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
